import { useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Preloader from "../common/Preloader";
import { isoToDate } from "../../utils/helpers";

function PlantProtectionTable({ cropId }) {
    const { user } = useAuth();
    const [plantprotectionrecords, setPlantProtectionRecords] = useState([]);
    const [totalActive, setTotalActive] = useState(0);
    const [totalDiActive, setTotalDiActive] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const [showPreloader, setShowPreloader] = useState(false);
    const [show, setShow] = useState(false);
    const [selectedPlantProtectionId, setSelectedPlantProtectionId] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/plantprotectionrecord/edit",
        },
        // {
        //     id: 1,
        //     name: "Planting",
        //     icon: "icon-address",
        //     routerPath: "/pla/workflowprocess",
        // },
        // {
        //     id: 3,
        //     name: "Delete",
        //     icon: "flaticon-transfer-1",
        //     onClick: (process) => {
        //         handleShow(process.id)
        //     },
        // }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (plantprotectionrecords && plantprotectionrecords.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        { width: "4%", targets: 0 },
                        { width: "12%", targets: 2 } 
                    ]
                });
            });
        }
    }, [plantprotectionrecords]);


    useEffect(() => {
        const fetchPlanting = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/plantprotectionrecords/crop/${cropId}`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching plant protection records');
                }
                const data = await response.json();
                console.log("plant records data >>:", data);
                setPlantProtectionRecords(data);
            } catch (error) {
                toast.error("Error fetching plant protection records.");
                console.error("Error fetching plant protection records:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchPlanting();
    }, [cropId]);


    const handleShow = (processId) => {
        setShow(true);
        setSelectedPlantProtectionId(processId);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedPlantProtectionId(null);
    };

    const handleRemoveFarm = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        setShowPreloader(true);
        try {

            if (!selectedPlantProtectionId) {
                console.error('No selected Services Provider ID');
                return;
            }

            const data = {
                id: selectedPlantProtectionId,
            }
            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
                body: JSON.stringify(data)
            };

            const response = await fetch(`${baseURL}/plantprotectionrecords/${selectedPlantProtectionId}`, requestOptions);
            if (response.ok) {
                toast.success("Plant Protection Record removed successfully");
                setShowPreloader(true);
                handleClose();
                window.location.reload();

            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Plant Record:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };



    return (
        <>
            <Preloader show={showPreloader} />
            <div className="main-container">

                <div className="row gutters">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">List of Plant Protection Records</div>
                                <Link
                                    to={`/plantprotectionrecord/create/?crop=${cropId}`}
                                    className="btn btn-primary float-end"
                                >
                                    <i className="icon-add"></i> Add Plant Protection Record
                                </Link>
                            </div>
                            <div className="card-body pt-0">
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        
                                            <div className="table-responsive">
                                                <table id="data-table" className="table custom-table">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th>Name of Product</th>
                                                            <th>Active Ingredients</th>
                                                            <th>Date</th>
                                                            <th>Maturity Stage Of Crop</th>
                                                            <th>Quantity Applied</th>
                                                            <th>Applied By</th>
                                                            <th>Supervised By</th>
                                                            <th><div className="float-end">Actions</div></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {plantprotectionrecords && plantprotectionrecords.length > 0 ? plantprotectionrecords.map((plantingRecord, index) => (
                                                            <tr key={index}>
                                                                <td>{plantingRecord.nameOfProduct}</td>
                                                                <td>{plantingRecord.activeIngredients}</td>
                                                                <td>{isoToDate(plantingRecord.date)}</td>
                                                                <td>{plantingRecord.maturityStageOfCrop}</td>
                                                                <td>{plantingRecord.quantityApplied} {plantingRecord.quantityAppliedUnit}</td>
                                                                <td>{plantingRecord.appliedBy}</td>
                                                                <td>{plantingRecord.supervisedBy}</td>
                                                                <td className="">
                                                                    <ul>
                                                                        <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                                            <div className="dropdown">
                                                                                <a
                                                                                    className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                                    role="button"
                                                                                    href="#"
                                                                                    id={"dropdownMenuLink" + plantingRecord.id}
                                                                                    data-bs-toggle="dropdown"
                                                                                >
                                                                                    Actions <i className="fa fa-caret-down"></i>
                                                                                </a>
                                                                                <ul
                                                                                    className="dropdown-menu"
                                                                                    aria-labelledby={"dropdownMenuLink" + plantingRecord.id}
                                                                                >
                                                                                    {profileMenuItems.map((actionMenuItem) => (
                                                                                        <li key={plantingRecord.id + '-' + actionMenuItem.id}>
                                                                                            {actionMenuItem.onClick ? (
                                                                                                <a
                                                                                                    href="#"
                                                                                                    className="dropdown-item"
                                                                                                    onClick={(e) => {
                                                                                                        e.preventDefault(); // Prevent default anchor behavior
                                                                                                        actionMenuItem.onClick(plantingRecord);
                                                                                                    }}
                                                                                                    style={
                                                                                                        isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                            ? { color: "#ff5a5f" }
                                                                                                            : undefined
                                                                                                    }
                                                                                                >
                                                                                                    <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                                </a>
                                                                                            ) : (
                                                                                                <Link
                                                                                                    to={actionMenuItem.routerPath + "/" + plantingRecord.id} // Changed href to to
                                                                                                    className="dropdown-item"
                                                                                                    style={
                                                                                                        isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                            ? { color: "#ff5a5f" }
                                                                                                            : undefined
                                                                                                    }
                                                                                                >
                                                                                                    <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                                </Link>
                                                                                            )}
                                                                                        </li>
                                                                                    ))}

                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                                    </tbody>
                                                </table>
                                                <Modal show={show} onHide={handleClose}>
                                                    <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                                        <Modal.Title style={{ color: 'white' }}>Delete Workflow Process</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p className="mb-4">
                                                            Are you sure you want to delete this workflowprocess?
                                                        </p>
                                                    </Modal.Body>
                                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                                        <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleClose}>
                                                            Cancel
                                                        </Button>
                                                        <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemoveFarm}>
                                                            Delete
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Row start */}

                {/* Row end */}

            </div>

        </>
    );
}

export default PlantProtectionTable;